import { DecisionsRPRequestModel } from './DecisionsRPRequestModel';
import { DecisionsRPResponse } from './DecisionsRPResponseModel';

export class DecisionsRPReponseViewModel{
    public autoRPRequest: DecisionsRPRequestModel = new DecisionsRPRequestModel();
    public autoRPResponse: DecisionsRPResponse = new DecisionsRPResponse();
}